// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7660":"css/admin-app.6784","8800":"css/app.6784"}[chunkId] + ".css";
};